import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareInsuranceBook', request)
}

export {post}
